import photoSrc from 'images/authors/savtym.jpg';

/**
 *  List of authors
 *  @param key{string}  - nickname
 *  @param value{object} :
 *    @param name{string}       - name of author
 *    @param photo{picture}     - photo of author
 * */
const authors = {
  savtym: {
    name: 'Tymofii Savytskyi',
    photo: photoSrc,
  },
};

export default authors;



// WEBPACK FOOTER //
// ./src/config/authors.js